import React from "react";
import { FormInput } from "../form-input";
import TextBase from "../text";
import { Colors } from "../../themes/Colors";

export function ACHDetail({
  values = {},
  validation = {},
}) {
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "calc(var(--sp-md2)*1.132075)",
          padding: "calc(var(--sp-md2)*1.132075) 0 calc(var(--sp-md2)*1.8867924) 0",
        }}
      >
        <div
          style={{
            width: "calc(var(--fs-hero)*1.179245)",
            height: "calc(var(--fs-hero)*1.179245)",
            borderRadius: "50%",
            background: "#eef2ff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "calc(var(--fs-xl)*1.132075)",
          }}
        >
          🏦 </div>
        <div
          style={{
            fontSize: "calc(var(--fs-xs)*1.6981132)",
            fontWeight: 600,
            color: "#1a1a1a",
            fontFamily: "Poppins, sans-serif",
          }}
        >
          {values?.bank_name || "Bank Account"}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "calc(var(--sp-md2)*1.132075)",
          marginBottom: "calc(var(--sp-md2)*2.35849)",
        }}
      >
        <div
          style={{
            width: "calc(var(--fs-hero)*1.179245)",
            height: "calc(var(--fs-hero)*1.179245)",
            borderRadius: "50%",
            background: "#f2f3f5",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "calc(var(--fs-xs)*1.8867924)",
            color: "#555",
          }}
        >
          👤
        </div>

        <div>
          <div
            style={{
              fontSize: "calc(var(--fs-xs)*1.5094339)",
              fontWeight: 600,
              color: "#000",
              fontFamily: "Poppins",
            }}
          >
            {values?.account_holder_name || "Account Holder"}
          </div>
          <div
            style={{
              fontSize: "calc(var(--fs-xs)*1.3207547)",
              color: "#666",
              fontFamily: "Poppins",
            }}
          >
            {values?.email || ""}
          </div>
        </div>
      </div>

      <FormInput
        disabled={true}
        value={values?.bank_name}
        label="Bank Name"
        placeholder="Bank Name"
      />

      <FormInput
        disabled={true}
        value={values?.account_type}
        label="Account Type"
        placeholder="Checking/Savings"
      />

      <FormInput
        disabled={true}
        value={values?.account_holder_type}
        label="Account Holder Type"
        placeholder="Individual/Company"
      />

      <FormInput
        disabled={true}
        value={`****${values?.last4 || ""}`}
        label="Account Number"
      />

      <FormInput
        disabled={true}
        value={values?.routing_number}
        label="Routing Number"
      />

      {validation?.general && (
        <TextBase
          fontWeight={400}
          size={"calc(var(--fs-xs)*1.3207547)"}
          color={Colors.red}
          style={{ marginTop: 'var(--sp-md2)' }}
        >
          {validation.general}
        </TextBase>
      )}
    </div>
  );
}